import * as Yup from 'yup'

import required from '@galo-monitor/forms/validators/required.validator'

const pesticideManufacturerSchema = ({ t }) => Yup.object().shape({
  name: required({ t })(Yup.string())
})

export default pesticideManufacturerSchema
